import React, { useState, useRef } from 'react'
import { setOpenAddNewTimeTable } from '../../../../../../../redux/globalSlice'
import { Box, Modal, Typography } from '@mui/material'
import { SelectField } from '../../../../../../../components'
import classes from './NewTimeTable.module.css'
import { useDispatch } from 'react-redux'
import { backarrow } from '../../../../../../../assets/images'
import { useGlobal } from '../../../../../../../shared'
import { urls } from '../../../../../../../shared/config'
import StudentBox from '../../../../../../../common/StudentBox/StudentBox'
import TimeTableModalTable from './TimeTableModalTable/TimeTableModalTable'
import AddTimeModal from '../AddTimeModal/AddTimeModal'

const NewTimeTable = ({
  open,
  customRole,
  userSchoolName,
  schoolList,
  userSchoolId,
  day,
  refetch,
}) => {
  const [step, setStep] = useState(1)
  const dispatch = useDispatch()
  const [schoolName, setSchoolName] = useState('')

  const timetableRef = useRef()

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: step === 2 ? 1046 : 471,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 0,
    outline: 'none',
    borderRadius: '12px',
  }

  const [formData, setFormData] = useState({
    grade: '',
    class: null, // full section object
  })

  const progressMap = {
    1: '50%',
    2: '100%',
  }
  const progress = progressMap[step] ?? '0%'

  const [formValues, setFormValues] = useState({
    period_name: '',
    start_date: '',
    end_time: '',
    type: '',
    section_map_id: '',
  })

  const handleNext = () => {
    if (step === 1) {
      if (!formData.grade || !formData.class) {
        alert('Please select Grade and Class')
        return
      }
      setStep(2)
    } else if (step === 2) {
      if (timetableRef.current?.handleSubmit) {
        timetableRef.current.handleSubmit()
      }
      // Optional: close after submit
      // dispatch(setOpenAddNewTimeTable(false))
    }
  }

  const handleBack = () => {
    if (step === 2) {
      setStep(1)
    }
  }

  const handleClose = () => {
    dispatch(setOpenAddNewTimeTable(false))
    setStep(1)
    setFormData({ grade: '', class: null })
  }

  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole === 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000`,
  })

  const selectedGradeObj = grades?.find((g) => String(g.grade_id) === String(formData?.grade))

  const typeEnums = [
    { label: 'Free Time', value: 'freeTime' },
    { label: 'Recess', value: 'recess' },
    { label: 'Subject', value: 'subject' },
  ]
  const getSectionMapId = (selectedSectionObj, gradeSections = []) => {
    if (!selectedSectionObj?.section_id) return ''

    const match = gradeSections.find(
      (sec) => String(sec.section_id) === String(selectedSectionObj.section_id),
    )
    return match?.section_map_id || ''
  }
  const handleGradeChange = (selectedGradeId) => {
    setFormData((prev) => ({
      ...prev,
      grade: selectedGradeId,
      class: null, // reset class when grade changes
    }))
    setFormValues((prev) => ({ ...prev, section_map_id: '' }))
  }
  const handleClassChange = (selectedSectionObj) => {
    setFormData((prev) => ({ ...prev, class: selectedSectionObj }))

    const mapId = getSectionMapId(selectedSectionObj, selectedGradeObj?.grade_sections || [])
    setFormValues((prev) => ({ ...prev, section_map_id: mapId }))
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {step === 1 ? (
            <>
              <div
                style={{
                  padding: '32px 32px 0px 32px',
                }}
                className="header-registration"
              >
                <p className="modalheadtxt">Add New Timetable</p>
                <div className="linear-progress">
                  <div className="linear-p-bar">
                    <div className="filled-area" style={{ width: progress }} />
                  </div>
                  <Typography>{step}/2</Typography>
                </div>
              </div>

              <div className={classes.container}>
                <div className={classes.top}>
                  <label style={{ margin: '0px' }} className="custom-selectfield-label">
                    Assigned Class
                    <span className="req">*</span>
                  </label>

                  {customRole !== 'Admin' && (
                    <SelectField
                      width={'100%'}
                      placeholder={'Select School'}
                      options={(schoolList || []).map((prod) => ({
                        value: prod.school_id,
                        label: prod.school_name,
                      }))}
                      name="schoolName"
                      value={schoolName}
                      onChange={(selectedOption) => setSchoolName(selectedOption)}
                    />
                  )}

                  <div className={classes.grid}>
                    <SelectField
                      placeholder={''}
                      options={(grades || []).map((m) => ({
                        value: m?.grade_id,
                        label: m?.grade,
                      }))}
                      value={formData?.grade}
                      onChange={(selectedOption) => handleGradeChange(selectedOption)}
                      label={''}
                      required={false}
                      width={'100%'}
                      subLabel={'Grade :'}
                    />

                    <SelectField
                      placeholder={''}
                      options={(selectedGradeObj?.grade_sections || []).map((prod) => ({
                        value: prod, // full object
                        label: prod.section || '',
                      }))}
                      value={formData?.class} // full object
                      onChange={(selectedOption) => handleClassChange(selectedOption)}
                      label={''}
                      required={false}
                      width={'100%'}
                      subLabel={'Class :'}
                      timetable
                    />
                  </div>
                </div>

                <div className={classes.bottom}>
                  <button onClick={handleClose} className={`${classes.flex} white-button`}>
                    Cancel
                  </button>

                  <button onClick={handleNext} className={`${classes.flex} primary-button`}>
                    Next
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className={classes.containerbox}>
                <div className="header-registration">
                  <div onClick={handleBack} className={classes.backbox}>
                    <img src={backarrow} alt="" className={classes.back} />
                    <p className={classes.boxtxt}>Back</p>
                  </div>
                  <div className="linear-progress">
                    <div className="linear-p-bar">
                      <div className="filled-area" style={{ width: progress }} />
                    </div>
                    <Typography>{step}/2</Typography>
                  </div>
                </div>

                <div className="header-registration">
                  <p className="modalheadtxt">Add New Timetable</p>
                </div>

                <div className={classes.vanbox}>
                  <StudentBox
                    student_grade={selectedGradeObj?.grade || '1'}
                    student_section={formData?.class?.section || 'A'} // ← use .section (string!)
                    timetable
                  />
                </div>

                <TimeTableModalTable
                  ref={timetableRef}
                  setFormValues={setFormValues}
                  formValues={formValues}
                  typeEnums={typeEnums}
                  gradeId={formData.grade}
                  sectionObj={formData.class} // full object passed to child
                  userSchoolId={userSchoolId}
                  customRole={customRole}
                  day={day}
                  refetch={refetch}
                  selectedGradeObj={selectedGradeObj}
                  
                />
              </div>

              <div className={`${classes.bottom} ${classes.end}`}>
                <button onClick={handleClose} className="white-button">
                  Cancel
                </button>

                <button onClick={handleNext} className="primary-button">
                  Next
                </button>
              </div>
            </>
          )}
        </Box>
      </Modal>
    </>
  )
}

export default NewTimeTable
